import axios from "axios";
import FeatherIcon from 'feather-icons-react';
import React, {Component} from "react";
import ReactToPrint from "react-to-print";
import Headerpdf from "../../users/Headerpdf";
import UserIdentity from "../../users/UserIdentity";
import AccoutingbalanceDetails from "./Accoutingbalance_";

class   Accoutingbalance extends Component{

    state = {
        isModal : false,
        formData : null,
        loading : false,
        monthId : null,
        chartacountId : null,
        accountingbalances : [],
        months : [
            { id : 5, month : 'Janvier'},
            { id : 6, month : 'Fevrier' },
            { id : 7, month : 'Mars' },
            { id : 8, month : 'Avril' },
            { id : 9, month : 'Mai' },
            { id : 10, month : 'Juin' },
            { id : 11, month : 'Juillet' },
            { id : 12, month : 'Aout' },
            { id : 1, month : 'Septembre' },
            { id : 2, month : 'Octombre' },
            { id : 3, month : 'Novembre' },
            { id : 4, month : 'Decembre' } ],
        periods : ['','Septembre', 'Octombre', 'Novembre', 'Decembre', 'Janvier','Fevrier','Mars','Avril','Mai','Juin','Juillet', 'Aout', ]
    }

    componentDidMount(){
        // var commitment_date = new Date();
        // commitment_date = commitment_date.getMonth();
        // this.setState({
        //     monthId : this.state.months[commitment_date]?.id
        // })
        this.getAccountingbalances();
    }

    handleInput = (e) => {
        this.getAccountingbalances();
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    showModal = (data = null, date) => {
        this.setState({
            isModal : !this.state.isModal,
            formData : { chartacount : data.wording, chartacountId : data.id, date : date},
        })
    }

    async getAccountingbalances(){
        this.setState({accountingbalances : [] , loading : false})
        var accountingbalances = await axios.get('accountingbalances/');
        if(accountingbalances.status === 200)
        {
            this.setState({ accountingbalances : accountingbalances.data , loading : true})
        }
    }

    formatMoney = (amount, currency) => {
        const value = parseFloat(amount || 0);
        if(!value) return "";
        return `${value.toLocaleString()} ${currency || ""}`.trim();
    }

    render(){
        var amount = "", amount_ ="", count = 1, date_ = null, createdAt = null, currency = [], chartacount = [{ id: -1, chartaccount : "Afficher tous"}];
        this.state.accountingbalances.forEach(curr => {
            if(currency.filter(dat => dat.currency === curr.chartaccount.currency).length === 0){
                currency.push({
                    amount : 0,
                    amount_ :  0,
                    currency : curr.chartaccount.currency
                })
            }

            if(chartacount.filter((val) => String(val.id) === String(curr.chartaccount.id))?.length === 0){
                chartacount.push({
                    id : curr.chartaccount?.id,
                    chartaccount : curr.chartaccount.wording
                })
            }
        })

        const filteredAccountingbalances = this.state.accountingbalances?.filter(val => String(val.chartaccount.id) === String(this.state.chartacountId) || this.state.chartacountId === null) || [];
        const activeChartaccount = chartacount.find(val => String(val.id) === String(this.state.chartacountId));
        const dailyDates = [];
        const totalsByCurrency = [];
        filteredAccountingbalances.forEach((accountingbalance) => {
            const currentCurrency = accountingbalance.chartaccount?.currency || "N/A";
            let currencyTotal = totalsByCurrency.find(total => total.currency === currentCurrency);
            if(!currencyTotal){
                currencyTotal = {
                    currency : currentCurrency,
                    debit : 0,
                    credit : 0,
                    balance : 0,
                };
                totalsByCurrency.push(currencyTotal);
            }
            currencyTotal.debit += parseFloat(accountingbalance.totalDebit || 0);
            currencyTotal.credit += parseFloat(accountingbalance.totalCredit || 0);
            currencyTotal.balance = currencyTotal.debit - currencyTotal.credit;
            if(dailyDates.filter(date => date === accountingbalance.createdAt).length === 0){
                dailyDates.push(accountingbalance.createdAt);
            }
        });

        return(
            <div className="finance-ledger-page">
                <div className="finance-ledger-hero">
                    <div className="finance-ledger-hero__title">
                        <span className="ev-dashboard__eyebrow">Livre de caisse</span>
                        <h1>Mouvement entrant-sortant journalier</h1>
                        <p>{activeChartaccount?.chartaccount || "Toutes les caisses"} - {dailyDates.length} jour(s) mouvemente(s)</p>
                    </div>

                    <div className="finance-ledger-hero__actions">
                        <label className="finance-ledger-select">
                            <FeatherIcon icon="briefcase" size="16" />
                            <select name="chartacountId" value={ this.state.chartacountId || "-1"} onChange={(e) => this.setState({ chartacountId : e.target.value === '-1' ? null : e.target.value })}>
                                {
                                    chartacount.map((va) => {
                                        return(
                                            <option value={va.id} key={va.id}>{ va.chartaccount }</option>
                                        )
                                    })
                                }
                            </select>
                        </label>

                        <ReactToPrint
                            trigger={() => <button className="btn btn-sm btn-outline-primary finance-ledger-print" type="button"><FeatherIcon icon={"printer"} size="18"></FeatherIcon> <span>Imprimer</span></button>}
                            content={() =>  this.componentRef}
                        />
                    </div>
                </div>

                <div className="finance-ledger-stats">
                    <article>
                        <span><FeatherIcon icon="calendar" size="17" /></span>
                        <div><strong>{dailyDates.length}</strong><small>Jour(s)</small></div>
                    </article>
                    {
                        totalsByCurrency.length === 0 ? (
                            <article className="finance-ledger-currency-card is-empty">
                                <span><FeatherIcon icon="info" size="17" /></span>
                                <div>
                                    <strong>Aucun total disponible</strong>
                                    <small>Les montants seront separes par devise apres chargement.</small>
                                </div>
                            </article>
                        ) : totalsByCurrency.map((total) => (
                            <article className="finance-ledger-currency-card" key={total.currency}>
                                <div className="finance-ledger-currency-card__head">
                                    <span>{total.currency}</span>
                                    <b>{this.formatMoney(total.balance, total.currency) || `0 ${total.currency}`}</b>
                                </div>
                                <dl>
                                    <div>
                                        <dt>Entrees</dt>
                                        <dd className="is-in">{this.formatMoney(total.debit, total.currency) || `0 ${total.currency}`}</dd>
                                    </div>
                                    <div>
                                        <dt>Sorties</dt>
                                        <dd className="is-out">{this.formatMoney(total.credit, total.currency) || `0 ${total.currency}`}</dd>
                                    </div>
                                </dl>
                            </article>
                        ))
                    }
                </div>

                <div className="finance-ledger-panel" ref={el => (this.componentRef = el)}>
                    <Headerpdf />
                    <UserIdentity title={ "Equilibre du caisse " + this.state.monthId + " mois"} />
                    <div className="finance-ledger-panel__header">
                        <div>
                            <span>Journal consolide</span>
                            <h2>Lecture journaliere des flux</h2>
                        </div>
                        <b>{filteredAccountingbalances.length} ligne(s)</b>
                    </div>
                    <div className="table-responsive finance-ledger-table-wrap">
                        <table className="table table-sm finance-ledger-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Caisse</th>
                                    <th scope="col">Entree</th>
                                    <th scope="col">Sortie</th>
                                    <th scope="col">Total</th>
                                    <th scope="col">Solde</th>
                                </tr>
                            </thead>
                            <tbody>
                                { !this.state.loading && (
                                    <tr>
                                        <td colSpan="7" className="finance-ledger-state">
                                            <FeatherIcon className="user-search-spin" icon="loader" size="21" />
                                            Chargement des mouvements
                                        </td>
                                    </tr>
                                )}
                                {
                                    this.state.loading && filteredAccountingbalances.length === 0 && (
                                        <tr>
                                            <td colSpan="7" className="finance-ledger-state">Aucun mouvement pour cette caisse.</td>
                                        </tr>
                                    )
                                }
                                {
                                    filteredAccountingbalances.map((accountingbalance) => {
                                        amount = "";
                                        amount_ = 0
                                        if(date_ === null){
                                            createdAt = accountingbalance.createdAt
                                            date_ = accountingbalance.createdAt
                                        }
                                        else if(date_ === accountingbalance.createdAt)
                                            createdAt = null
                                        else{
                                            createdAt = accountingbalance.createdAt
                                            date_ = accountingbalance.createdAt
                                        }
                                        currency.forEach((curr, index) => {
                                            if(curr.currency === accountingbalance.chartaccount.currency)
                                            {
                                                currency[index].amount = parseFloat(currency[index].amount) + parseFloat(accountingbalance.totalDebit || 0) - parseFloat(accountingbalance.totalCredit || 0);
                                                currency[index].amount_ = createdAt === accountingbalance.createdAt ? parseFloat(accountingbalance.totalDebit || 0) - parseFloat(accountingbalance.totalCredit || 0) : parseFloat(currency[index].amount_) + parseFloat(accountingbalance.totalDebit || 0) - parseFloat(accountingbalance.totalCredit || 0);
                                                amount = currency[index].amount > 0 ? this.formatMoney(currency[index].amount, accountingbalance.chartaccount.currency) : "";
                                                amount_ = this.formatMoney(currency[index].amount_, accountingbalance.chartaccount.currency)
                                            }
                                        })

                                        return(
                                            <tr key={accountingbalance.id} className={createdAt ? "finance-ledger-date-row" : ""}>
                                                <td align="right">{createdAt ? count++ : '' }</td>
                                                <td align="center" type="button" onClick={() => this.showModal(accountingbalance.chartaccount, accountingbalance.createdAt)}><span className="finance-ledger-date">{createdAt ? new Date(createdAt).toLocaleDateString("en-GB") : ''}</span></td>
                                                <td align="center"><span className="finance-ledger-account" type="button" onClick={() => this.showModal(accountingbalance.chartaccount, accountingbalance.createdAt)}>{accountingbalance.chartaccount.wording}</span></td>
                                                <td align="right" className="finance-ledger-money is-in">{this.formatMoney(accountingbalance.totalDebit, accountingbalance.chartaccount.currency)}</td>
                                                <td align="right" className="finance-ledger-money is-out">{this.formatMoney(accountingbalance.totalCredit, accountingbalance.chartaccount.currency)}</td>
                                                <td align="right" className="finance-ledger-money">{amount_}</td>
                                                <td align="right" className="finance-ledger-money is-balance">{amount}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                            {
                                totalsByCurrency.length > 0 && (
                                    <tfoot>
                                        {totalsByCurrency.map((total) => (
                                            <tr key={total.currency}>
                                                <td colSpan="3">Total {total.currency}</td>
                                                <td align="right" className="finance-ledger-money is-in">{this.formatMoney(total.debit, total.currency) || `0 ${total.currency}`}</td>
                                                <td align="right" className="finance-ledger-money is-out">{this.formatMoney(total.credit, total.currency) || `0 ${total.currency}`}</td>
                                                <td align="right" colSpan="2" className="finance-ledger-money is-balance">{this.formatMoney(total.balance, total.currency) || `0 ${total.currency}`}</td>
                                            </tr>
                                        ))}
                                    </tfoot>
                                )
                            }
                        </table>
                    </div>
                </div>

                <AccoutingbalanceDetails
                    isModal ={ this.state.isModal }
                    showModal ={ this.showModal }
                    date ={ this.state.formData?.date}
                    chartacountId ={ this.state.formData?.chartacountId}
                    chartacount ={ this.state.formData?.chartacount}
                />
            </div>
        )
    }
}
export default Accoutingbalance;
